'use client';

import { PayoutResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

interface ResultsDisplayProps {
  result: PayoutResult;
  translations: ToolsTranslations['payout'];
}

export default function ResultsDisplay({ result, translations }: ResultsDisplayProps) {
  return (
    <div className="space-y-4">
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultEarningsLabel}</div>
        <div className="text-2xl font-bold text-blue-900">
          {result.payoutEarningsPercent !== null ? `${result.payoutEarningsPercent.toFixed(0)}%` : '—'}
        </div>
      </div>
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultCashFlowLabel}</div>
        <div className="text-2xl font-bold text-blue-900">
          {result.payoutCashFlowPercent !== null ? `${result.payoutCashFlowPercent.toFixed(0)}%` : '—'}
        </div>
      </div>
      <div className="p-4 bg-blue-50 rounded-lg border border-blue-100">
        <div className="text-sm text-gray-600">{translations.resultFreeCashFlowLabel}</div>
        <div className="text-2xl font-bold text-blue-900">
          {result.payoutFreeCashFlowPercent !== null ? `${result.payoutFreeCashFlowPercent.toFixed(0)}%` : '—'}
        </div>
      </div>
      {!result.isValid && (
        <div className="text-xs text-red-600 mt-2">
          {translations.invalid.generic}
        </div>
      )}
    </div>
  );
}


